import axiosInstance from './axiosConfig';

// ✅ role normalizer (supports SUPERADMIN, superadmin, Admin, etc.)
const normalizeRole = (role) => role?.toLowerCase();

const creditService = {
  /**
   * Get all credit collections based on user role
   */
  getAll: async (page = 1, limit = 1000, userRole = null, userId = null) => {
    const role = normalizeRole(userRole);

    console.log('creditService.getAll called with:', {
      page,
      limit,
      role,
      userId,
    });

    try {
      // ✅ Use the collections endpoint
      const response = await axiosInstance.get('/credits/all/collections', {
        params: { page, limit }
      });

      const res = response.data;

      // ✅ normalize API response
      if (Array.isArray(res)) return res;
      if (Array.isArray(res.data)) return res.data;
      if (Array.isArray(res.data?.collections)) return res.data.collections;
      if (Array.isArray(res.data?.credits)) return res.data.credits;

      return [];
    } catch (error) {
      console.error('Error fetching credit collections:', error);
      throw error;
    }
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/credits/${id}`);
    return response.data;
  },

  getActive: async (userRole = null, userId = null) => {
    const role = normalizeRole(userRole);
    let response;

    if (role === 'superadmin') {
      response = await axiosInstance.get('/credits/active');
    } else if (role === 'admin') {
      if (!userId) {
        throw new Error('User ID is required for admin role');
      }
      response = await axiosInstance.get(`/credits/${userId}/active`);
    } else {
      throw new Error(`Invalid user role: ${userRole}`);
    }

    return response.data.data.map((cred) => ({
      value: cred.id,
      text: cred.name,
    }));
  },

  create: async (data) => {
    const response = await axiosInstance.post('/credits/create', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/credits/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/credits/delete/${id}`);
    return response.data;
  },

  filter: async (filters = {}, userRole = null, userId = null) => {
    const role = normalizeRole(userRole);
    const params = new URLSearchParams();

    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    let url = '';

    if (role === 'superadmin') {
      url = params.toString()
        ? `/credits?${params.toString()}`
        : '/credits';
    } else if (role === 'admin') {
      if (!userId) {
        throw new Error('User ID is required for admin role');
      }
      url = params.toString()
        ? `/credits/${userId}/by-user?${params.toString()}`
        : `/credits/${userId}/by-user`;
    } else {
      throw new Error(`Invalid user role: ${userRole}`);
    }

    const response = await axiosInstance.get(url);

    const res = response.data;
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.data?.credits)) return res.data.credits;

    return [];
  },
};

export default creditService;